<template>
  <div class="container">
    <div v-show="!shrink" class="left-container">
      <version-list-block />
    </div>
    <div class="shrink" @click="switchShrink">
      <a-icon class="shrink-icon" :type="shrink === false ? 'left' : 'right'" />
    </div>
    <div class="right-container">
      <version-detail :version-id="versionId" />
    </div>
  </div>
</template>

<script>
import VersionDetail from '@/pages/project/version/components/VersionDetail';
import VersionListBlock from '@/pages/project/version/components/VersionListBlock';

export default {
  components: { VersionDetail, VersionListBlock },
  data() {
    return {
      versionId: null,
      shrink: false
    };
  },
  watch: {
    $route() {
      this.versionId = parseInt(this.$route.query.version_id) || null;
    }
  },
  mounted() {
    this.versionId = parseInt(this.$route.query.version_id) || null;
  },
  methods: {
    updated() {
      this.$refs.versions.getVersionList();
    },
    switchShrink() {
      this.shrink = !this.shrink;
    }
  }
};
</script>

<style lang="less" scoped>
.container {
  display: flex;
  width: 100%;
  height: calc(~'100vh - 100px');
  background-color: #fff;
  border: 1px solid #edeef1;
  padding: 8px 8px 8px 0;
  border-radius: 12px;
}
.left-container {
  width: 220px;
  border-right: 1px solid #edeef1;
}
.right-container {
  flex: 1; /*  重点 */
  overflow: hidden;
}

.shrink {
  margin-top: calc(~'50vh - 88px');
  width: 12px;
  height: 40px;
  border: 1px solid #e5e5e5;
  border-left: 0px;
  float: left;
  background-color: #e5e5e5;
  border-radius: 0 6px 6px 0;
  .shrink-icon {
    color: #fff;
    line-height: 40px;
    font-size: 12px;
    font-weight: bold;
  }
}
.shrink:hover {
  background-color: #1890ff;
  border: 1px solid #1890ff;
  .shrink-icon {
    color: #fff;
  }
}
</style>
